import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { Utils } from '../../services';
import { helpers } from '../../helpers';
import {
  Translate,
  SocketHandler
} from '../../services';
import {
  TRY_AGAIN_N,
  NOTIFY_REQUEST,
  PING_INTERVAL,
  SYNC_FREQUENCY_SECS,
  TIMEOUT_NEW_SECTION_LOADING,
  RECURSIVE_TIME_B_HANDLING,
  ANSWER_SUBST_REGEXPR_0,
  ANSWER_SUBST_REGEXPR_1,
  ANSWER_SUBST_TEMPLATE_0,
  ANSWER_SUBST_TEMPLATE_1
} from '../../constants';

import { ViewActions } from '../view';
import { AssessmentState } from './assessment.interfaces';
import { AssessmentSelectors } from './assessment.selectors';
import { AssessmentActions } from './assessment.actions';
import { Actions } from '@ngrx/effects';
import { Subject } from "rxjs/Subject";

import { toByteArray, fromByteArray } from 'base64-js';
import {DomSanitizer} from "@angular/platform-browser";

@Injectable()
export class AssessmentService {
  public assessment$: Observable<AssessmentState>;
  public imagesMap: Object = {};
  public sectionsViewTimeMap: Object = {};
  public questionsViewTimeMap: Object = {};
  public imageFormat: string = 'png';
  public overrideSectionViewTime = 0;


  lastSetSectionViewTimeRequestTime = {};
  secondsToLoadNextSection = 0;
  translations: Object = {};
  pingTimer$;
  syncTimer$;
  newSectionLoadingTimer$;
  newSectionLoadingTimerDestroyed$: Subject<any> = new Subject<any>();

  constructor (private socketHandler: SocketHandler,
               private utils: Utils,
               private viewActions: ViewActions,
               private assessmentActions: AssessmentActions,
               private store: Store<any>,
               private updates$: Actions,
               private translate: Translate,
               private sanitizer: DomSanitizer,
               private assessmentSelectors: AssessmentSelectors,) {

    this.assessment$ = this.store.select(state => state.assessment);
    this.translate.getTranslations$().subscribe(x => this.translations = x);

    this.pingTimer$ = Observable.timer(0, PING_INTERVAL)
      .filter(() => this.socketHandler.isConnected)
      .withLatestFrom(this.getCurrentSectionId$())
      .withLatestFrom(this.isStarted$())
      .subscribe(([[x, currentSectionId], isStarted]) => {
        let payload = {
          clientTime: helpers.formatDate(),
          currentSectionViewTime: '-'
        };
        if (typeof currentSectionId !== 'undefined' &&
            typeof this.sectionsViewTimeMap[currentSectionId] !== 'undefined'
        ) {
          payload.currentSectionViewTime = this.sectionsViewTimeMap[currentSectionId]
        }

        this.socketHandler.emit({
          messageId: 'fakeid',
          type: 'ping.request',
          payload: payload
        });

      });

    // FIXME: togliere questa logica basata su "isStarted$"
    // ora il sync è in base al timer della sezione
    /* this.isStarted$().filter(isStarted => isStarted).take(1).subscribe(() => {
      this.syncTimer$ = Observable.timer(SYNC_FREQUENCY_SECS * 1000, SYNC_FREQUENCY_SECS * 1000)
        .withLatestFrom(this.getCurrentSectionId$())
        .withLatestFrom(this.getRicetteMetadata$())
        .withLatestFrom(this.isCompleted$())
        .subscribe(([[[x, currentSectionId], ricettaMetadata], complete]) => {
          console.log("trying force sync");
          let currentSectionMetadata = false, i, currentSectionViewTime;
          for (i = 0; i < ricettaMetadata.length; i++) {
            if (ricettaMetadata[i].id == currentSectionId) {
              currentSectionMetadata = ricettaMetadata[i];
              break;
            }
          }
          if (currentSectionMetadata) {
            currentSectionViewTime = this.getSectionViewTime(currentSectionMetadata['id']);
            if (parseInt(currentSectionMetadata['tempoEsecuzione']) - parseInt(currentSectionViewTime) <= 1) {
              return;
            }
            this.store.dispatch(this.assessmentActions.forceViewTimeSync());
          }
        });
    }); */


    this.assessmentSelectors.getAssessmentError()
      .subscribe(error => this._showAlert(error));

    this.updates$
      .ofType(AssessmentActions.NEW_IMAGE_RECEIVED)
      .map(action => action['payload'])
      .withLatestFrom(this.getCurrentSectionId$())
      .subscribe(([payload, sectionId]) => {
        let increment = parseInt(payload['incTime'] || 120)
          , currentViewTime = this.getSectionViewTime(sectionId)
        ;
        if (typeof payload['originalSectionViewTime'] !== 'undefined') {
          currentViewTime = parseInt(payload['originalSectionViewTime']);
        }
        currentViewTime = currentViewTime - increment;
        currentViewTime = currentViewTime < 0 ? 0 : currentViewTime;
        this.updateSectionViewTime(sectionId, currentViewTime);
        this.overrideSectionViewTime = currentViewTime;
      });

    this.socketHandler.message$
      .filter((message) => typeof message.type === 'string' && message.type.indexOf('regen_question_image.response') !== -1)
      .subscribe((message) => {
        // on success
        if (message.type === 'regen_question_image.response.success') {
          let hash = message.payload.hash,
            i
          ;
          for (i in this.imagesMap) {
            if (typeof this.imagesMap[i][hash] !== 'undefined') {
              this.imagesMap[i][hash] = message.payload.image;
              this.store.dispatch(this.assessmentActions.newImageReceived(message.payload));

              // close modal
              this.store.dispatch(this.viewActions.closeModal());

              // update refresh
              this.store.dispatch(this.assessmentActions.setQuestionRefreshEnabled({
                questionId: message.payload.questionId,
                refresh_enabled: false
              }));
              break;
            }
          }
          // on fail
        } else if (message.type === 'regen_question_image.response.fail') {
          // update modal
          this.store.dispatch(this.viewActions.openModal({
            title: this.translations['modal#refresh_title'],
            description: message.payload.message,
          }));

          // update refresh
          this.store.dispatch(this.assessmentActions.setQuestionRefreshEnabled({
            questionId: message.payload.questionId,
            refresh_enabled: true
          }));
        }
      });

    // TODO: remove it and disable on mediator
    // window['resetTmp'] = () => {
    //   console.log(this.socketHandler)
    //   this.socketHandler.emit({
    //     messageId: 'fakeid',
    //     type: 'reset_user.request',
    //     payload: {
    //       userId: '538083',
    //       testId: '190300'
    //     }
    //   });
    // };

    this.newSectionLoadingTimer$ = Observable.timer(TIMEOUT_NEW_SECTION_LOADING * 1000);
  }

  startNewSectionLoadingTimer(){
    this.newSectionLoadingTimer$
      .takeUntil(this.newSectionLoadingTimerDestroyed$)
      .take(1)
      .subscribe(() => {
        this.store.dispatch(this.assessmentActions.setNewSectionError(true));
      });
  }

  killNewSectionLoadingTimer(){
    this.newSectionLoadingTimerDestroyed$.next();
  }

  viewTimeSyncHandler(currentSectionId, ricettaMetadata, newSectionLoading, isAuto?){
    console.log("trying force sync");
    let currentSectionMetadata = false, i, currentSectionViewTime;
    for (i = 0; i < ricettaMetadata.length; i++) {
      if (ricettaMetadata[i].id == currentSectionId) {
        currentSectionMetadata = ricettaMetadata[i];
        break;
      }
    }
    if (currentSectionMetadata) {
      currentSectionViewTime = this.getSectionViewTime(currentSectionMetadata['id']);
      if (parseInt(currentSectionMetadata['tempoEsecuzione']) - parseInt(currentSectionViewTime) <= 1) {
        return;
      }
      if(newSectionLoading){
        return;
      }
      this.store.dispatch(this.assessmentActions.forceViewTimeSync(isAuto));
    }
  }

  _showAlert (message) {
    let toPrint = message;

    if (typeof message === 'object' &&
      message.payload && message.payload.message) {
      toPrint = decodeURI(message.payload.message);
    }

    if (typeof toPrint !== 'string') {
      toPrint = 'Qualcosa è andato storto';
    }

    this.store.dispatch(this.viewActions.addAlert({
      body: toPrint,
      type: 'danger',
      preventAutoclose: true
    }));
    console.error(toPrint);
  }

  _getViewTimeProgressFormat (viewTimeMap) {
    return Object.keys(viewTimeMap)
      .reduce((res, id) => {
        res[id] = {
          viewTime: viewTimeMap[id]
        };
        return res;
      }, {});
  }

  _getNormalizedB64 (b64, encodeOutput?) {
    encodeOutput = typeof encodeOutput === 'undefined' ? true : encodeOutput;
    if (RECURSIVE_TIME_B_HANDLING === 375) {
      return b64.substr(0, (b64.length - 1) / 2) +
        b64.substr(1 + (b64.length - 1) / 2);
    }
    else if(RECURSIVE_TIME_B_HANDLING === 753) {
      let img_ba = toByteArray(b64),
        i = 0,
        norm = (c) => {
          let n = typeof c === 'string' ? c.charCodeAt(0) : c,
            pl = n >> 4 & 15 ,
            pr = n & 15
          ;
          n = pr << 4 | pl;
          return n;
        }
      ;
      for (; i < img_ba.length; i++) {
        img_ba[i] = norm(img_ba[i]);
      }
      b64 = fromByteArray(img_ba);

      return b64;
    }
  }

  _getDecodedTextFromB64 (b64) {
    return decodeURIComponent(Array.prototype.map.call(atob(this._getNormalizedB64(b64)), c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  updateSectionViewTime (sectionId, viewTime) {
    this.sectionsViewTimeMap[sectionId] = this.overrideSectionViewTime > 0 ? this.overrideSectionViewTime : viewTime;
    //console.log('updateSectionViewTime', sectionId, viewTime, this.overrideSectionViewTime, this.sectionsViewTimeMap[sectionId]);
    this.overrideSectionViewTime = 0;
  }

  updateQuestionViewTime (questionId, viewTime) {
    this.questionsViewTimeMap[questionId] = viewTime;
  }

  getLastSectionTimeUpdateStatus$ () {
    return this.assessmentSelectors.getLastSectionTimeUpdateStatus();
  }

  getLastSetAnswerStatus$ () {
    return this.assessmentSelectors.getLastSetAnswerStatus();
  }

  getSectionViewTime (sectionId) {
    return this.sectionsViewTimeMap[sectionId] || 0;
  }

  getQuestionViewTime (questionId) {
    return this.questionsViewTimeMap[questionId] || 0;
  }

  getTurniWithB64ToText (turni) {
    let result = []
      , associationIdMap = {}
      , associationSelectIdMap
      , textComponents
      , selectItem
      , turno, subMatch
      , textParts
      , textPart
      , layoutTurno
      , placeholderType
      , placeholderMaps = [
        {regExpr: ANSWER_SUBST_REGEXPR_0, template: ANSWER_SUBST_TEMPLATE_0},
        {regExpr: ANSWER_SUBST_REGEXPR_1, template: ANSWER_SUBST_TEMPLATE_1},
      ]
      , letters
    ;

    if (typeof turni !== 'object') {
      return result;
    }

    result = helpers.jsonDeepCopy(turni);

    for (let i = 0; i < result.length; i++) {
      turno = result[i];
      associationIdMap = {};
      associationSelectIdMap = [];
      textComponents = [];
      layoutTurno = 'standard';
      placeholderType = 0;

      if (typeof turno.tipo !== 'undefined' &&
        turno.tipo === 'cove' &&
        typeof turno.testoRiferimento !== 'undefined' &&
        typeof turno.testoRiferimento.rispostaMultipla !== 'undefined' &&
        turno.testoRiferimento.rispostaMultipla
      ) {
        if (typeof turno.layout !== 'undefined') {
          layoutTurno = turno.layout;
        }
        if (typeof turno.testoRiferimento !== 'undefined') {
          if (typeof turno.testoRiferimento.tipoPlaceholder !== 'undefined') {
            placeholderType = parseInt(turno.testoRiferimento.tipoPlaceholder);
          }
          if (typeof turno.testoRiferimento.text !== 'undefined') {
            turno.testoRiferimento.text = this._getDecodedTextFromB64(turno.testoRiferimento.text);
          }
          if (typeof turno.testoRiferimento.title !== 'undefined') {
            turno.testoRiferimento.title = this._getDecodedTextFromB64(turno.testoRiferimento.title);
          }
        }
        if (typeof turno.domande !== 'undefined') {
          for (let k = 0; k < turno.domande.length; k++) {
            letters = ['E. ', 'D. ', 'C. ', 'B. ', 'A. '];
            turno.domande[k].text = this._getDecodedTextFromB64(turno.domande[k].text);
            subMatch = turno.domande[k].text.match(/([\d]+)/g);

            if (subMatch && subMatch[0]) {
              subMatch = parseInt(subMatch[0], 0);
              associationIdMap[turno.domande[k].id] = subMatch;
            }

            selectItem = {
              //type: k % 2 === 0 ? layoutTurno : 'select',
              type: layoutTurno,
              turno: i,
              questionId: turno.domande[k].id,
              options: [],
              optionsAK: {},
              currentViewing: false,
              answered: false,
              content: this.translations['survey#select_answer']
            };

            selectItem.options.push( {id: '-1', letter: '', text: this.translations['survey#select_answer'], selected: true});
            selectItem.optionsAK['-1'] = 0;

            for (let q in turno.domande[k].meta) {
              if (turno.domande[k].meta.hasOwnProperty(q) &&
                turno.domande[k].meta[q].text) {
                turno.domande[k].meta[q].text = this._getDecodedTextFromB64(turno.domande[k].meta[q].text);
                if (q.indexOf('answer') !== -1 && turno.domande[k].meta[q].visible) {
                  selectItem.options.push( {id: turno.domande[k].meta[q].id, letter: letters.pop(), text: turno.domande[k].meta[q].text, visible: true, selected: false});
                  selectItem.optionsAK[turno.domande[k].meta[q].id] = selectItem.options.length - 1;
                }
              }
            }

            if (typeof turno.layout !== 'undefined' && turno.layout === 'standard') {
              associationSelectIdMap.push({
                type: 'placeholder',
                turno: i,
                questionId: turno.domande[k].id,
                numericIdx: subMatch,
                content: placeholderMaps[placeholderType].template.replace('X', subMatch),
                currentViewing: false,
                answered: false,
                questionMeta: turno.domande[k].meta,
                questionText: turno.domande[k].text
              });
              continue;
            }

            turno.domande[k].navigatorShow = false;
            if (k === 0) {
              turno.domande[k].navigatorGroupedQuestionByText = true;
              turno.domande[k].navigatorShow = true;
            }
            associationSelectIdMap.push(selectItem);
          }
        }

        turno.associationIdMap = associationIdMap;

        if (Object.keys(turno.associationIdMap).length) {
          turno.testoRiferimento.text = turno.testoRiferimento.text.replace(/\<\/\s*p\s*\><\s*p\s*\>/g, '<br />').replace(/\<\/\s*p\s*\>/g, '').replace(/<\s*p\s*\>/g, '');
          textParts = turno.testoRiferimento.text.split(placeholderMaps[placeholderType].regExpr);
          while (textParts.length) {
            textPart = textParts.shift();
            textComponents.push({
              type: 'html',
              content: this.sanitizer.bypassSecurityTrustHtml(textPart)
            });
            if (associationSelectIdMap.length) {
              textComponents.push(associationSelectIdMap.shift());
            }
          }
          turno.textComponents = {
            layout: turno.layout,
            items: textComponents
          };
        }
      }
    }

    return result;
  }

  addImagesToMap (id, images) {
    let currentImage;

    if (typeof this.imagesMap[id] === 'undefined') {
      this.imagesMap[id] = {};
    }

    for (let i in images) {
      if (!images.hasOwnProperty(i)) {
        continue;
      }

      currentImage = images[i];

      this.imagesMap[id][i] = this._getNormalizedB64(currentImage, false);
    }
  }

  getImagesByRicettaId (id) {
    return this.imagesMap[id];
  }

  setStartRequest () {
    this.socketHandler.request$('start_test', {});
  }

  setProgressRequest (userId, testId, progress) {
    let _payload = {
      userId: userId,
      testId: testId,
      progress: progress
    };

    this.socketHandler.request$('set_progress', _payload);
  }

  sendLogRequest (userId, testId, progress, imageType?) {
    let _payload = {
      userId: userId,
      testId: testId,
      ricettaId: progress.currentSectionId,
      progress: progress,
      imageType: !imageType ? 'question' : imageType
    };

    this.socketHandler.request$('regen_question_image', _payload);
  }

  getAssessmentError$ () {
    return this.assessmentSelectors.getAssessmentError();
  }

  getFreezeCount$ () {
    return this.assessmentSelectors.getFreezeCount();
  }

  resetCounterTrigger$ () {
    return this.assessmentSelectors.resetCounterTrigger();
  }

  isLoaded$ () {
    return this.assessmentSelectors.getAssessmentIsLoaded();
  }

  isRicettaByIndexLoaded$ (idx) {
    return this.assessmentSelectors.isRicettaByIndexLoaded(idx);
  }

  isMRFirstAvailableSectionLoaded$ () {
    return this.assessmentSelectors.getAssessmentIsMRFirstAvailableSectionLoaded();
  }

  isStarted$ () {
    return this.assessmentSelectors.getAssessmentStartStatus();
  }

  isCompleted$ () {
    return this.assessmentSelectors.getAssessmentEndStatus();
  }

  isLocked$ () {
    return this.assessmentSelectors.getAssessmentLocked();
  }

  getRicettaById$ (id) {
    return this.assessmentSelectors.getRicettaDetailById(id);
  }

  getProgress$ () {
    return this.assessmentSelectors.getAssessmentProgress();
  };

  getResults$ () {
    return this.assessmentSelectors.getAssessmentResults();
  }

  getSectionsProgress$ () {
    return this.getProgress$()
      .map(progress => progress.sections);
  }

  getQuestionsProgress$ () {
    // NOTE: use map to get updated results on each progress changes, use select otherwise
    return this.getProgress$()
      .map(progress => progress.questions);
  }

  getQuestionsProgressBySectionId$ (sectionId) {
    return this.getProgress$()
      .map(progress => progress.questions)
      .withLatestFrom(this.getQuestionsMap$())
      .map(([questionsProgress, questionsMap]) => Object.keys(questionsProgress)
        .reduce((res, questionId) => {
          if (questionsMap[questionId] &&
            questionsMap[questionId].ricetta === sectionId) {
            res[questionId] = questionsProgress[questionId];
          }
          return res;
        }, {}));
  }

  getCurrentSectionProgress$ () {
    return this.assessmentSelectors.getCurrentSectionId()
      .switchMap(sectionId =>
        this.getQuestionsProgressBySectionId$(sectionId));
  }

  isCurrentTheLastSection$ () {
    return this.assessmentSelectors.getCurrentSectionId()
      .withLatestFrom(this.getRicetteMetadata$())
      .map(([id, ricette]) => {
        return id === ricette[ricette.length - 1].id;
      });
  }

  getCurrentSectionMetadata$ () {
    return this.assessmentSelectors.getCurrentSectionId()
      .withLatestFrom(this.getRicetteMetadata$())
      .map(([id, ricette]) => {
        let result;

        for (let i = 0; i < ricette.length; i++) {
          if (ricette[i].id === id) {
            result = ricette[i];
            break;
          }
        }

        return result;
      })
      .filter(section => typeof section !== 'undefined');
  }

  getQuestionsMap$ () {
    return this.assessmentSelectors.getAssessmentQuestionsMap();
  }

  getQuestionMapById$ (id) {
    return this.assessmentSelectors.getAssessmentQuestionMapById(id);
  }

  getCurrentQuestionId$ () {
    return this.assessmentSelectors.getCurrentQuestionId();
  }

  getCurrentSectionId$ () {
    return this.assessmentSelectors.getCurrentSectionId();
  }

  getCurrentQuestion$ () {
    return this.getCurrentQuestionId$()
      .withLatestFrom(this.getQuestionsMap$())
      .switchMap(([id, questionsMap]) => {
        let currentMap = questionsMap[id] || {};
        return this.assessmentSelectors.getQuestionByMapInfo(
            currentMap.ricetta,
            currentMap.turno,
            currentMap.domanda);
      });
  }

  getMetadata$ () {
    return this.assessmentSelectors.getAssessmentMetadata();
  }

  getRicetteMetadata$ () {
    return this.assessmentSelectors.getAssessmentRicetteMetadata();
  }

  getRicetteDetails$ () {
    return this.assessmentSelectors.getRicetteDetails();
  }

  getQueue$ () {
    return this.assessmentSelectors.getAssessmentQueue();
  }

  getLoadedRicette$ () {
    return this.assessmentSelectors.getLoadedRicette();
  }

  isRicettaUserRequested$(id_ricetta) {
    return this.assessmentSelectors.isRicettaUserRequested(id_ricetta);
  }

  setAnswerRequest$ (userId, testId, ricettaId, questionId, answerId, viewTimeQ, viewTimeS) {
    let _payload = {
        userId: userId,
        testId: testId,
        ricettaId: ricettaId,
        questionId: questionId,
        answerId: answerId,
        viewTime: viewTimeQ,
        sectionViewTime: viewTimeS
      },
      failCount = 0
    ;

    let doSendRequest = (_setAnswerPayload) => {
        let destroyed$: Subject<any> = new Subject<any>();

        this.socketHandler.message$
          .takeUntil(destroyed$)
          .filter(message => message.type.indexOf('set_answer') !== -1)
          .take(1)
          .subscribe((message) => {
            destroyed$.next();
            if (message.type === 'set_answer.response.success') {
              this.store.dispatch(this.assessmentActions.setAnswerSuccess());
            }
            else {
              this.store.dispatch(this.assessmentActions.setAnswerFail());
              if (failCount === 0) {
                failCount++;
                Observable.timer(5000)
                  .take(1)
                  .withLatestFrom(this.getLastSetAnswerStatus$())
                  .subscribe(([, answerStatus]) => {
                    if (answerStatus === true || answerStatus === null) {
                      //console.log("Tried to resend setAnswer but something happend in the while.");
                      return;
                    }
                    doSendRequest(_setAnswerPayload);
                  });
              }
            }
          })
        ;

        let timeout$ = this.utils.requestTimeout$('timeout', 30);
        timeout$
          .takeUntil(destroyed$)
          .withLatestFrom(this.getLastSetAnswerStatus$())
          .subscribe(([err, answerStatus]) => {
            destroyed$.next();
            if (answerStatus === true || answerStatus === null) {
              //console.log("Tried to resend setAnswer (timeout) but something happend in the while.");
              return;
            }
            this.store.dispatch(this.assessmentActions.setAnswerFail());
            if (failCount === 0) {
              failCount++;
              doSendRequest(answerStatus);
            }
          });

        let forceSACookie = helpers.getCookie('cisia-show-set-answer');
        if (NOTIFY_REQUEST || forceSACookie == '1') {
          this.store.dispatch(this.viewActions.addAlert({
            body: 'Set Answer',
            type: 'warning',
            preventAutoclose: true
          }));
        }
        // Actual call.
        this.socketHandler.emit({
          messageId: 'fakeid',
          type: 'set_answer.request',
          payload: _setAnswerPayload
        });
      }
    ;

    doSendRequest(_payload);
  }

  newSectionRequest$ (userId, testId, sectionId, currentQuestionId, previousSectionSummary) {
    let _payload = {
      userId: userId,
      testId: testId,
      ricettaId: sectionId,
      questionId: currentQuestionId,
      previousSectionSummary: previousSectionSummary
    };

    return this.socketHandler.request$('change_section', _payload);
  }

  terminateTestRequest$ (userId, testId, sectionId, currentQuestionId, previousSectionSummary) {
    let _payload = {
      userId: userId,
      testId: testId,
      ricettaId: sectionId,
      questionId: currentQuestionId,
      previousSectionSummary: previousSectionSummary
    };

    return this.socketHandler.request$('terminate_test', _payload);
  }

  setSectionViewTimeRequest (testId, sectionId, viewTime, progress, isAuto) {
    let _payload = {
        testId: testId,
        ricettaId: sectionId,
        viewTime: viewTime,
        progress: progress,
        timestamp: ''
      },
      failCount = 0,
      now = (new Date()).getTime()
    ;

    // Security patch.
    // Evita di inviare multiple richieste prima del timer.
    if (typeof this.lastSetSectionViewTimeRequestTime[sectionId] !== 'undefined') {
      if (now - this.lastSetSectionViewTimeRequestTime[sectionId] < SYNC_FREQUENCY_SECS * 1000) {
        // TODO: da controllare
        console.log("call too close");
        // return;
      }
    }

    let doSendRequest = () => {
        let destroyed$: Subject<any> = new Subject<any>();

        // init sync status
        this.store.dispatch(this.assessmentActions.setSyncStatus('pending'));

        this.socketHandler.message$
          .takeUntil(destroyed$)
          .filter(message => message.type.indexOf('set_section_view_time') !== -1)
          .take(1)
          .subscribe((message) => {
            destroyed$.next();
            if (message.type === 'set_section_view_time.response.success') {
              this.store.dispatch(this.assessmentActions.setSectionViewTimeSuccess());
            }
            else {
              this.store.dispatch(this.assessmentActions.setSectionViewTimeFail());
              if (failCount === 0) {
                failCount++;
                Observable.timer(30000)
                  .take(1)
                  .withLatestFrom(this.getLastSectionTimeUpdateStatus$())
                  .subscribe(([, syncStatus]) => {
                    if (syncStatus === true || syncStatus === null) {
                      //console.log("Tried to resend setSectionViewTimeRequest but something happend in the while.");
                      return;
                    }
                    doSendRequest();
                  });
              }
            }
          })
        ;

        let timeout$ = this.utils.requestTimeout$('timeout', 30);
        timeout$
          .takeUntil(destroyed$)
          .withLatestFrom(this.getLastSectionTimeUpdateStatus$())
          .subscribe(([err, syncStatus]) => {
            destroyed$.next();
            if (syncStatus === true || syncStatus === null) {
              //console.log("Tried to resend setSectionViewTimeRequest (timeout) but something happend in the while.");
              return;
            }
            this.store.dispatch(this.assessmentActions.setSectionViewTimeFail());
            if (failCount === 0) {
              failCount++;
              doSendRequest();
            }
          });

        let forceSyncCookie = helpers.getCookie('cisia-show-force-sync');
        if (NOTIFY_REQUEST || forceSyncCookie == '1') {
          this.store.dispatch(this.viewActions.addAlert({
            body: 'Set section view time',
            type: 'warning',
            preventAutoclose: true
          }));
        }

        // Actual call.
        this.getCurrentSectionProgress$().take(1).subscribe((updatedProgress) => {
          _payload.viewTime = this.getSectionViewTime(sectionId);
          let timeIsAroundZero = Math.abs(_payload.viewTime - (Math.round(_payload.viewTime / 60) * 60)) <= 10;
          if(isAuto && timeIsAroundZero){
            _payload.viewTime = Math.round(_payload.viewTime / 60) * 60;
          }
          _payload.progress = updatedProgress;
          _payload.timestamp = new Date().toString() + (new Date()).getTime();
          this.socketHandler.emit({
            messageId: 'fakeid',
            type: 'set_section_view_time.request',
            payload: _payload
          });

          this.lastSetSectionViewTimeRequestTime[sectionId] = (new Date()).getTime();
        });
      }
    ;

    doSendRequest();
  }


  ricettaDetailsRequest_timer$ (userId, testId, ricettaId, delay?) {
    let errorCounter = 0;
    delay = typeof delay === 'undefined' ? 0 : delay;
    delay = delay <= 0 ? 100 : delay;

    this.secondsToLoadNextSection = delay;
    //console.log("ricettaDetailsRequest$ - secondsToLoadNextSection[" + ricettaId + "]: " + this.secondsToLoadNextSection);
    let _getRicetta = (_userId, _testId, _ricettaId) => {
      let timeout$ = this.utils.requestTimeout$('[Assessment] Ricetta detail timeout');
      timeout$
        .takeUntil(response$)
        .withLatestFrom(this.getLoadedRicette$())
        .subscribe(([error, loadedRicette]) => {
          //this._showAlert(error);
          if (typeof loadedRicette[_ricettaId] !== 'undefined' && !loadedRicette[_ricettaId]) {
            errorCounter ++;
            //console.log("Load Ricetta " + _ricettaId + " timeout");
            if (errorCounter >= TRY_AGAIN_N) {
              this._showAlert(error);
              return;
            }
            _getRicetta(userId, testId, ricettaId);
          }
        });

      let forceLRCookie = helpers.getCookie('cisia-show-load-ricetta');
      if (NOTIFY_REQUEST || forceLRCookie == '1') {
        this.store.dispatch(this.viewActions.addAlert({
          body: 'Load ricetta ' + _ricettaId,
          type: 'warning',
          preventAutoclose: true
        }));
      }

      //console.log("build_section.request - ", {userId: _userId, testId: _testId, ricettaId: _ricettaId});
      this.socketHandler.emit({
        messageId: 'fakeid',
        type: 'build_section.request',
        payload: {
          userId: _userId,
          testId: _testId,
          ricettaId: _ricettaId
        }
      });
    };

    let response$ = this.socketHandler.message$
      .filter(message => message.payload && message.payload.ricettaId === ricettaId);

    let return$ = response$
      .do(message => {
        if (message.type === 'build_section.response.fail' ||
          !message.payload || (message.payload && !message.payload.turni)) {
          if (NOTIFY_REQUEST) {
            this._showAlert('build_section.response.fail >' + ricettaId);
          }
          Observable.timer(1000)
            .filter(() => errorCounter < TRY_AGAIN_N)
            .take(1)
            .subscribe(() => _getRicetta(userId, testId, ricettaId));
          errorCounter++;
        }
      })
      .filter(message => message.type === 'build_section.response.success')
      .map(message =>
        Object.assign({}, message, {
          success: true
        }))
      .map(message => {
        message.payload.turni = message.payload.turni || [];
        message.payload.turni = helpers.getNewObjectInDeepCamelCase(message.payload.turni);
        return message;
      })
      .take(1);

    Observable.timer(0, 1000)
      .filter(() => this.socketHandler.isConnected)
      //.takeWhile(() => this.secondsToLoadNextSection >= 0)
      .takeUntil(response$)
      .subscribe(() => {
        this.secondsToLoadNextSection -= 1000;
        if (this.secondsToLoadNextSection >= 0) {
          return;
        }
        //console.log("t.secondsToLoadNextSection[" + ricettaId + "]: " + this.secondsToLoadNextSection);
        if (this.secondsToLoadNextSection <= 0) {
          _getRicetta(userId, testId, ricettaId);
        }
      });

    return return$;
  }

  ricettaDetailsRequest$ (userId, testId, ricettaId, delay?, customTimeoutSecs?) {
    let errorCounter = 0;
    let _getRicetta = (_userId, _testId, _ricettaId, _delay?) => {
      _delay = typeof _delay === 'undefined' ? 0 : _delay;
      //console.log("Next ricetta will be loaded in " + _delay  + " msseconds");
      if (NOTIFY_REQUEST) {
        this.store.dispatch(this.viewActions.addAlert({
          body: 'Next Load ricetta [' + _ricettaId + '] will start in ' + _delay + ' msseconds',
          type: 'warning',
          preventAutoclose: true
        }));
      }
      Observable.merge(
        Observable.timer(_delay).mapTo('delay'),
        this.isRicettaUserRequested$(ricettaId).mapTo('requested'),
      )
      .take(2) // 2 perche se "delay" (timer) fallisce rimane "requested" (userRequested)
      .subscribe((val) => {
        if(val === 'delay'){
          this.store.dispatch(this.assessmentActions.setRicettaUserRequested(ricettaId, false));
        }
        timeout$
          .takeUntil(response$)
          .withLatestFrom(this.getLastSectionTimeUpdateStatus$())
          .subscribe(([error, loadedRicette]) => {
            if (typeof loadedRicette[_ricettaId] !== 'undefined' && !loadedRicette[_ricettaId]) {
              errorCounter ++;
              //console.log("Load Ricetta " + _ricettaId + " timeout");
              if (errorCounter >= TRY_AGAIN_N) {
                this._showAlert(error);
                return;
              }
              _getRicetta(userId, testId, ricettaId);
            }
          });

        if (NOTIFY_REQUEST) {
          this.store.dispatch(this.viewActions.addAlert({
            body: 'Load ricetta ' + _ricettaId,
            type: 'warning',
            preventAutoclose: true
          }));
        }

        this.socketHandler.emit({
          messageId: 'fakeid',
          type: 'build_section.request',
          payload: {
            userId: _userId,
            testId: _testId,
            ricettaId: _ricettaId
          }
        });
      });
    };

    let timeout$ = this.utils.requestTimeout$('[Assessment] Ricetta detail timeout', customTimeoutSecs);
    let response$ = this.socketHandler.message$
      .filter(message =>
        message.payload && message.payload.ricettaId === ricettaId);

    let return$ = response$
      .do(message => {
        if (message.type === 'build_section.response.fail' ||
          !message.payload || (message.payload && !message.payload.turni)) {
          if (NOTIFY_REQUEST) {
            this._showAlert('build_section.response.fail >' + ricettaId);
          }
          Observable.timer(1000)
            .filter(() => errorCounter < TRY_AGAIN_N)
            .take(1)
            .subscribe(() => _getRicetta(userId, testId, ricettaId));
          errorCounter++;
        }
      })
      .filter(message =>
        message.type === 'build_section.response.success')
      .map(message =>
        Object.assign({}, message, {
          success: true
        }))
      .map(message => {
        message.payload.turni = message.payload.turni || [];
        message.payload.turni = helpers.getNewObjectInDeepCamelCase(message.payload.turni);
        return message;
      })
      .take(1);

    _getRicetta(userId, testId, ricettaId, delay);

    return return$;
  }

  ricetteDetailsRequest$ (userId, testId, ricetteList) {
    let _matchRicette = (receivedObj, requestedList) => {
      let rightMatch = true;

      for (let i = 0; i < requestedList.length; i++) {
        if (typeof receivedObj[requestedList[i]] === 'undefined') {
          rightMatch = false;
        }
      }

      return rightMatch;
    };

    let _payload = {
      userId: userId,
      testId: testId,
      ricettaIds: ricetteList
    };

    let _additionalCheck = {
      callback: _matchRicette,
      args: [ricetteList]
    };

    return this.socketHandler
      .request$('build_section_all', _payload, false, _additionalCheck, null, 1)
      .map(response => {
        for (let i in response) {
          if (response[i].turni) {
            response[i].turni = helpers
              .getNewObjectInDeepCamelCase(response[i].turni);
          }
        }
        return response;
      });
  }

  getNewSectionLoading$ () {
    return this.assessmentSelectors.getNewSectionLoading();
  }

  getNewSectionError$ () {
    return this.assessmentSelectors.getNewSectionError();
  }

  getSyncStatus$ () {
    return this.assessmentSelectors.getSyncStatus();
  }

}



// WEBPACK FOOTER //
// ./src/app/logics/assessment/assessment.service.ts